<template lang="pug">
section.chatbot-settings
    .not-configured(v-if="!knowledgeSource")
        p {{ $t('No knowledge source configured for this CMS.') }}

    //- The chatbot's persona. The knowledge base it answers from is shared with
    //- KI-Inhalte and has its own tab (KnowledgeBase.vue).
    .details(v-else)
        h4 {{ $t('System Prompt') }}
        p.description {{ $t('Custom instructions appended after the built-in security prompt. Leave empty to use the default prompt only.') }}

        el-form-item(:label="$t('Custom Prompt')")
            el-input(
                v-model="knowledgeSource.system_prompt"
                type="textarea"
                :rows="6"
                :maxlength="2000"
                show-word-limit
            )

        .security-prompt-info.mb-6
            h4 {{ $t('Built-in Security Prompt') }}
            p.description {{ $t('This prompt is always prepended unless the override toggle underneath is enabled. It adapts automatically to your enabled extensions, indexed content types, and enabled chatbot tools.') }}
            pre.security-prompt-text {{ securityPrompt }}

        el-form-item.no-margin
            .override-toggle
                el-switch(
                    v-model="knowledgeSource.system_prompt_overrides_base"
                    :active-text="$t('Replace built-in security prompt entirely')"
                )
            .override-warning(v-if="knowledgeSource.system_prompt_overrides_base")
                i.el-icon-warning
                |  {{ $t('Warning: This disables the built-in security rules. The chatbot will only follow your custom prompt.') }}
</template>

<i18n>
{
    "de": {
        "No knowledge source configured for this CMS.": "Keine Wissensquelle für dieses CMS konfiguriert.",
        "System Prompt": "System Prompt",
        "Custom instructions appended after the built-in security prompt. Leave empty to use the default prompt only.": "Benutzerdefinierte Anweisungen, die nach dem eingebauten Sicherheits-Prompt angehängt werden. Leer lassen, um nur den Standard-Prompt zu verwenden.",
        "Custom Prompt": "Benutzerdefinierter Prompt",
        "Replace built-in security prompt entirely": "Eingebauten Sicherheits-Prompt vollständig ersetzen",
        "Warning: This disables the built-in security rules. The chatbot will only follow your custom prompt.": "Warnung: Dies deaktiviert die eingebauten Sicherheitsregeln. Der Chatbot befolgt nur noch Ihren benutzerdefinierten Prompt.",
        "Built-in Security Prompt": "Eingebauter Sicherheits-Prompt",
        "This prompt is always prepended unless the override toggle underneath is enabled. It adapts automatically to your enabled extensions, indexed content types, and enabled chatbot tools.": "Dieser Prompt wird immer vorangestellt, es sei denn, der untere Schalter ist aktiviert. Er passt sich automatisch an Ihre aktivierten Erweiterungen, indexierten Inhaltstypen und aktivierten Chatbot-Tools an."
    }
}
</i18n>

<script>
import _ from 'lodash';
import { useSettingsStore } from '@/stores';

export default {
    name: 'ChatbotSettings',
    computed: {
        knowledgeSource() {
            return _.get(useSettingsStore().form, 'knowledgeSource');
        },
        securityPrompt() {
            return _.get(this.knowledgeSource, 'base_system_prompt') || '';
        },
    },
};
</script>

<style lang="sass" scoped>
.chatbot-settings
    min-height: 200px
    .not-configured
        padding: 40px
        text-align: center
        color: #909399

.details
    h4
        margin: 0 0 8px
        font-size: 1rem
        font-weight: 600

    .description
        color: #909399
        font-size: 0.875rem
        margin: 0 0 16px

.override-toggle
    display: flex
    align-items: center

.override-warning
    margin-top: 8px
    padding: 8px 12px
    background-color: #fef0f0
    border: 1px solid #fde2e2
    border-radius: 4px
    color: #f56c6c
    font-size: 0.875rem

    .el-icon-warning
        margin-right: 4px

.security-prompt-text
    background: #f5f7fa
    border: 1px solid #e4e7ed
    border-radius: 4px
    padding: 12px 16px
    font-size: 0.875rem
    line-height: 1.6
    color: #606266
    white-space: pre-wrap
    word-wrap: break-word
    font-family: inherit
    margin: 0
</style>
